import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TableHead extends Component{

	render(){
		const heads = this.props.columns;
		const header = heads.map(heads => {
			return(
				<th key={heads} className={this.props.headstyle}>{heads}</th>
		)});
		return(
				<tr className="br3">
				{header}
				</tr>
		);
	}
}

TableHead.propTypes = {
	columns: PropTypes.array.isRequired,
	headstyle: PropTypes.string
};


// WEBPACK FOOTER //
// ./src/component/TableHead.js